var _react_refresh_temp_1;
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LogOut04Icon, MenuItem, Separator, translate, } from '@lucidlink/uicore';
import { managementPlatformRoutes } from '#services';
export const UserMenuGoToManagementPlatformOption = () => {
    return (_jsxs(_Fragment, { children: [_jsx(Separator, {}), _jsx(MenuItem, { "data-testid": "go-to-management-platform", LeadingIcon: LogOut04Icon, text: translate('Go to management platform'), to: managementPlatformRoutes.root() })] }));
};
_react_refresh_temp_1 = UserMenuGoToManagementPlatformOption;
$RefreshReg$(_react_refresh_temp_1, "UserMenuGoToManagementPlatformOption");
